export default __webpack_public_path__ + "static/media/plan-a-media-group-book-intro-session.f2f37137.gif";